const MAP = {
  new: { label: "New", bg: "bg-zinc-100", text: "text-zinc-700", dot: "bg-zinc-500" },
  not_connected: { label: "Not Connected", bg: "bg-zinc-100", text: "text-zinc-700", dot: "bg-zinc-500" },
  completed: { label: "Completed", bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-600" },
  hold: { label: "Hold", bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-600" },
  rejected: { label: "Rejected", bg: "bg-red-50", text: "text-red-700", dot: "bg-red-600" },
  follow_up: { label: "Follow-up", bg: "bg-blue-50", text: "text-blue-700", dot: "bg-blue-600" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.new;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-sm px-2 py-0.5 text-xs font-medium ${s.bg} ${s.text}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {s.label}
    </span>
  );
}
